<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png" alt="菜单" />
      </div>
      <div class="caidan-title">维修记录</div>
    </div>
    <div class="modul-content">
      <!-- 查询 -->
      <div class="query-form">
        <el-form :inline="true" :model="form" ref="form">
          <el-form-item label="桥梁名称">
            <el-select
              v-model="form.bridgeName"
              filterable
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in bridgeData"
                :key="index"
                :label="item.bridgeName"
                :value="item.bridgeName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间">
            <el-date-picker
              v-model="time"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="timeChange"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            ><el-button type="primary" @click="tableReq(1)"
              >查询</el-button
            ></el-form-item
          >
        </el-form>
        <el-form :inline="true">
          <el-form-item
            ><el-button @click="update">新增</el-button></el-form-item
          >
          <!-- <el-form-item>
            <el-button 
                       @click="onExport">导出</el-button>
          </el-form-item> -->
        </el-form>
      </div>
      <el-table
        class="tableStyle"
        v-loading="loading"
        height="calc(100vh - 350px)"
        border
        style="width: 100%"
        :data="tableData"
        :header-cell-style="{background: '#FAFAFA', color: '#000000'}"
      >
        <el-table-column
          label="序号"
          align="left"
          type="index"
          width="50px"
        ></el-table-column>
        <el-table-column
          prop="bridgeName"
          label="桥梁"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="maintenanceTime"
          label="维修时间"
          align="left"
        ></el-table-column>
        <el-table-column prop="maintenanceType" label="维修类型" align="left">
          <template slot-scope="scope">
            <div>
              {{ scope.maintenanceType === 1 ? '巡检问题' : '数据采集' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="maintenanceUnitName"
          label="维修单位"
          align="left"
        ></el-table-column>
        <el-table-column label="维修档案" align="left">
          <template slot-scope="scope">
            <img
              src="@/assets/image/old/文件夹@2x.png"
              alt=""
              style="width: 20px; height: 20px; margin-right: 5px"
            />
            <a
              href="javascript:void(0);"
              @click="detailsRow(scope.row)"
              style="color: #11528b"
              >{{ scope.row.maintenanceDocumentName }}</a
            >
          </template>
        </el-table-column>
        <el-table-column prop="status" label="操作" align="left">
          <template #default="scope">
            <div>
              <el-button type="text" @click="update(scope.row)">编辑</el-button>
              <el-button type="text" @click="del(scope.row)">删除</el-button>
              <el-button type="text" @click="detailsRow(scope.row)"
                >下载</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--  -->
    <div style="text-align: center; margin: 20px 0 0">
      <!--描述：分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.pageNum"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000]"
        :page-size="form.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 点击处理弹出框 -->
    <div class="caozuotianbiao" :style="addmod == true ? 'display: none;' : ''">
      <el-form
        class="caozuotianbiao-from"
        label-width="90px"
        label-position="right"
        :rules="rules"
        ref="dispose"
        style="
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          align-content: center;
        "
      >
        <div class="modul-top" style="position: absolute; top: 5px">
          <div class="caidan-img">
            <img src="../../../assets/image/caidan.png" alt="菜单" />
          </div>
          <div class="caidan-title">维修记录</div>
        </div>
        <div
          class="caidan-img"
          style="
            position: absolute;
            top: 15px;
            right: 15px;
            border-radius: 50%;
            overflow: hidden;
            width: 30px;
            height: 30px;
          "
          @click="quxiao"
        >
          <img
            src="../../../assets/image/old/删除@2x.png"
            alt="关闭"
            style="width: 100%; height: 100%"
          />
        </div>
        <el-row style="margin-top: 40px; width: 80%">
          <el-col :span="11">
            <el-form-item label="桥梁名称" prop="bridgeUuid">
              <el-select
                v-model="bridgeUuid"
                filterable
                clearable
                @change="bridgeChanges"
                placeholder="请选择桥梁"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in bridgeDatas"
                  :key="index"
                  :label="item.bridgeName"
                  :value="item.bridgeUuid"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item
              label="维修日期"
              style="width: 100%"
              prop="maintenanceTime"
            >
              <el-date-picker
                v-model="maintenanceTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期时间"
                @change="timeChanges"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="width: 80%">
          <el-col :span="11">
            <el-form-item
              label="维修单位"
              style="width: 100%"
              prop="maintenanceUnitName"
            >
              <el-input
                type="text"
                v-model="maintenanceUnitName"
                placeholder="请输入维修单位"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="width: 80%">
          <el-col :span="11">
            <el-form-item
              label="维修类型"
              style="width: 100%"
              prop="maintenanceType"
            >
              <el-radio-group v-model="maintenanceType">
                <el-radio :label="1">巡检问题</el-radio>
                <el-radio :label="2">数据采集</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="上传台账" style="width: 100%">
              <el-upload
                class="upload-demo"
                drag
                :action="api + '/file/upload'"
                :limit="1"
                :on-success="success"
                :file-list="fileList"
                multiple
                accept=".jpg,.png,.docx,.doc,.pdf"
                :before-upload="uploadSheZhi"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
                <div slot="tip" class="el-upload__tip">
                  只能上传.jpg/.png/.docx/.doc/.pdf文件，且不超过10M
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="position: absolute; bottom: 0; right: 15px">
          <el-button type="primary" @click="isOK">确定</el-button>
          <el-button @click="quxiao">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeqingBridgeAndTunnelShebeiliebiao',
  props: [],
  data() {
    return {
      form: {
        bridgeName: '',
        startTime: '',
        endTime: '',
        pageNum: 1,
        pageSize: 10
      },
      dispose: {
        bridgeName: '',
        bridgeUuid: '',
        createName: '',
        createUuid: '',
        maintenanceDocumentName: '',
        maintenanceDocumentUrl: '',
        maintenanceTime: '',
        maintenanceUnitName: '',
        maintenanceUnitUuid: '',
        maintenanceType: 1
      },
      time: '',
      equipmentUuid: '',
      inspectionDate: '',
      rules: {
        bridgeUuid: [
          {
            required: true,
            message: ' ',
            trigger: 'change'
          }
        ]
      },
      loading: false,
      tableData: [],
      total: 0,
      bridgeData: [],
      bridgeDatas: [],
      bridgeName: '',
      bridgeUuid: '',
      maintenanceTime: '',
      maintenanceUnitName: '',
      maintenanceType: 1,
      addmod: true, //修改新增表单显示隐藏
      fileList: []
    }
  },

  mounted() {
    this.getBiBridgeBoPage()
    this.tableReq()
  },
  computed: {
    api() {
      return this.$config.host
    }
  },
  methods: {
    async tableReq(page) {
      this.loading = true
      console.log(this.form)
      this.loading = false
      const res = await this.$api.sendPost(
        '/biMaintenanceRecord/getBiMaintenanceRecord',
        this.form
      )
      console.log(res)
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          this.tableData = res.data.list
        } else {
          this.tableData = []
        }
      }
    },
    // 分页器----新每页条数
    handleSizeChange(val) {
      this.form.pageSize = val
      this.tableReq(1)
    },
    // 分页器-----新当前页
    handleCurrentChange(val) {
      this.form.pageNum = val
      this.tableReq()
    },
    // 获取-桥梁名称列表
    async getBiBridgeBoPage() {
      let data = {
        pageSize: 99999,
        pageNum: 1
      }
      const res = await this.$api.sendPost('/biBridge/getBiBridgeBoPage', data)
      console.log('桥梁名称', res)
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          this.bridgeData = res.data.list
          this.bridgeDatas = res.data.list
        } else {
          this.bridgeData = []
          this.bridgeDatas = []
        }
      }
    },
    bridgeChanges(e) {
      console.log(e)
      this.dispose.bridgeUuid = e
    },
    //新增和操作
    update(data) {
      ;(this.fileList = null), (this.bridgeName = '')
      this.bridgeUuid = ''
      this.maintenanceTime = ''
      this.maintenanceUnitName = ''
      this.addmod = false
      if (data.maintenanceDocumentUrl != undefined) {
        this.dispose = data
        this.fileList = [
          {name: data.maintenanceDocumentName, url: data.maintenanceDocumentUrl}
        ]
        this.bridgeName = data.bridgeName
        this.bridgeUuid = data.bridgeName
        this.maintenanceTime = data.maintenanceTime
        this.maintenanceUnitName = data.maintenanceUnitName
        this.maintenanceType = data.maintenanceType
      }
      console.log(this.dispose)
    },
    //操作按钮
    operate(data) {},
    async isOK() {
      this.dispose.createByName = this.$store.state.user.accountName
      this.dispose.createByUuid = this.$store.state.user.accountUuid
      this.dispose.maintenanceUnitName = this.maintenanceUnitName
      this.dispose.maintenanceType = this.maintenanceType
      this.addmod = true
      if (this.bridgeDatas && this.bridgeDatas.length > 0) {
        if (this.dispose.bridgeUuid != '') {
          let add = this.bridgeData.find((item) => {
            return this.dispose.bridgeUuid == item.bridgeUuid
          })
          this.dispose.bridgeName = add.bridgeName
        } else {
          this.dispose.bridgeName = ''
        }
      }
      console.log('确认修改', this.dispose)
      const res = await this.$api.sendPost(
        '/biMaintenanceRecord/saveOrUpdate',
        this.dispose
      )
      console.log('状态', res)
      if (res.errcode === 0) {
        this.tableReq(1)
      } else {
      }
      this.dispose = {
        bridgeName: '',
        bridgeUuid: '',
        createName: '',
        createUuid: '',
        maintenanceDocumentName: '',
        maintenanceDocumentUrl: '',
        maintenanceTime: '',
        maintenanceUnitName: '',
        maintenanceUnitUuid: '',
        maintenanceType: '1'
      }
      this.fileList = []
    },
    quxiao() {
      console.log('取消')
      this.addmod = true
    },
    //删除
    async del(data) {
      console.log(data.id)
      const res = await this.$api.sendGet('/biMaintenanceRecord/delete', {
        id: data.id
      })
      this.tableReq()
    },
    //时间选择
    timeChange(e) {
      console.log(e)
      let time = JSON.parse(JSON.stringify(e))
      console.log(time)
      if (time != undefined && time.length > 0) {
        this.form.startTime = time[0]
        this.form.endTime = time[1]
      } else {
        this.form.startTime = ''
        this.form.endTime = ''
      }
    },
    timeChanges(e) {
      console.log(e)
      this.$set(this.dispose, 'maintenanceTime', e)
      // this.dispose.maintenanceTime=e
    },
    //下载
    detailsRow(data) {
      console.log('下载数据', data)
      const a = document.createElement('a')
      a.href = data.maintenanceDocumentUrl
      // a.download = '文件名1'; // 下载后文件名
      a.setAttribute('download', data.maintenanceDocumentName)
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click() // 点击下载
      document.body.removeChild(a) // 下载完成移除元素
    },
    //上传文件
    success(response, file, fileLis) {
      console.log('上传文件信息', response)
      this.dispose.maintenanceDocumentName = response.data.fileName
      this.dispose.maintenanceDocumentUrl = response.data.urlPath
      // console.log('上传成功',response);
      // console.log('桥梁信息',this.addAndAmendData);
    },
    uploadSheZhi(file) {
      if (file.size > 10 * 1024 * 1024) {
        alert('上传文件过大')
        return false //必须返回false
      } else {
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.zhuangtai {
  display: flex;
  align-items: center;
  justify-content: center;
}

.warning-value {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.el-menu-vertical-demo {
  height: 600px;
}

.caozuotianbiao {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.caozuotianbiao-from {
  position: relative;
  text-align: left;
  width: 70%;
  height: 70%;
  background-color: #fff;
  padding: 20px;
}
</style>
